var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMicronesia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9991 6.95654L16.6897 9.08229H18.9249L17.1167 10.3961L17.8073 12.5218L15.9991 11.208L14.1907 12.5218L14.8816 10.3961L13.0732 9.08229H15.3084L15.9991 6.95654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95605 16.0002L9.0818 15.3095V13.0742L10.3956 14.8826L12.5213 14.1919L11.2076 16.0002L12.5213 17.8083L10.3956 17.1176L9.0818 18.9259V16.6908L6.95605 16.0002Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9992 25.0435L15.3085 22.9178H13.0732L14.8816 21.604L14.1909 19.4783L15.9992 20.792L17.8074 19.4783L17.1166 21.604L18.9249 22.9178H16.6898L15.9992 25.0435Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0428 16L22.917 16.6907V18.9259L21.6032 17.1176L19.4775 17.8083L20.7913 16L19.4775 14.1918L21.6032 14.8826L22.917 13.0742V15.3094L25.0428 16Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMicronesia);
export default __webpack_public_path__ + "static/media/flag_micronesia.d1f09ff4c30bc703936a1ebe35366fd5.svg";
export { ForwardRef as ReactComponent };